// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const gristMill = defineModel({
  id: "grist-mill",
  batchId: "future",
  name: "Grist mill",
  tags: ["building","grist","mill","low-poly","age-of-mcp","future"],
  summary: "Grinds grain, ore, malt or pigment — shared milling power for many chains.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.45, 1.1), color: "#8d8678", position: [0, 0.365, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [-0.75, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [0.75, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [-0.75, 0.365, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [0.75, 0.365, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, 0.775] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.9, 1.1), color: "#8d8678", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.75, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.75, 0.59, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.775, 0.7, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.775, 0.7, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.775, 0.7, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.775, 0.7, 0.775] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.9, 1.1), color: "#8d8678", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.75, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.75, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.800608), color: "#7a4a36", position: [0, 1.25, 0.305], rotation: [0.602983, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.800608), color: "#7a4a36", position: [0, 1.25, -0.305], rotation: [-0.602983, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.74, 0.085, 0.085), color: "#5a3526", position: [0, 1.46, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#5a4530", position: [0, 0.4, 0.56] },
      { geometry: new THREE.CylinderGeometry(0.32, 0.32, 0.12, 14), color: "#7d7870", position: [-0.6, 0.48, 0.52], rotation: [0.18, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.14, 8), color: "#6c665a", position: [-0.6, 0.48, 0.52], rotation: [1.750796, 0, 0] },
      { geometry: new THREE.SphereGeometry(0.14, 6, 5), color: "#cdbf9a", position: [0.6, 0.26, 0.56], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.SphereGeometry(0.14, 6, 5), color: "#c2b48e", position: [0.74, 0.26, 0.46], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.SphereGeometry(0.13, 6, 5), color: "#cdbf9a", position: [0.66, 0.44, 0.52], scale: [1, 0.82, 1.08] },
    ] },
  ],
  animations: [],
});
